export default __webpack_public_path__ + "static/media/3.a316e5ea.png";